import getLocalString from "constants/Localization";
import { useUpdateOrganizationProposalChecklistItemMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateOrganizationProposalChecklistItem() {
  const [mutation, { loading, data, error }] = useUpdateOrganizationProposalChecklistItemMutation({
    refetchQueries: ["organizationProposalChecklistItems"],
  });

  const [updateOrganizationProposalChecklistItem, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateOrganizationProposalChecklistItem",
    },
    {
      successMessage: getLocalString("organization.update-checklist-item-success"),
      failureMessage: getLocalString("organization.update-checklist-item-failure"),
    }
  );

  return [updateOrganizationProposalChecklistItem, context] as const;
}
